import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ContainerName } from "../../shared/container/container-name.type.const";
import { EquipmentQuantity } from "../models/equipment-quantity.model";
import { EventService } from "app/shared/event/event.service";
import { eventType } from "app/notify/event.const";
import { Quote } from "../quote.type";
import { Bind } from "primeng/bind";
import { Checkbox } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";
import { Select } from "primeng/select";
import { Tooltip } from "primeng/tooltip";
import { InputText } from "primeng/inputtext";
import { DigitOnlyDirective } from "@uiowa/digit-only";
import { FormatContainerLabelPipe } from "../../shared/container/format-container-label.pipe";
import { SortEquipmentPipe } from "../../shared/container/sort-equipment.pipe";

@Component({
  selector: "app-equipment-quantity",
  templateUrl: "./equipment-quantity.component.html",
  styleUrls: ["./equipment-quantity.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    "[class.has-grand-total]": "showGrandTotal",
  },
  imports: [
    InputText,
    Bind,
    Checkbox,
    FormsModule,
    Select,
    Tooltip,
    DigitOnlyDirective,
    FormatContainerLabelPipe,
    SortEquipmentPipe,
  ],
})
export class EquipmentQuantityComponent implements OnInit, OnChanges {
  private eventService = inject(EventService);

  public readonly equipment = input<ContainerName[]>([]);
  @Input() public equipmentQuantity: Map<string, EquipmentQuantity>;
  @Input() public showGrandTotal = false;
  @Input() public grandTotalCurrency: string;
  public readonly currencySelectList = input([]);
  public readonly quote = input<Quote>(undefined);
  readonly dispatchedQuoteEvents = output<{
    equipmentQuantity: Map<string, EquipmentQuantity>;
    showGrandTotal: boolean;
    grandTotalCurrency: string;
  }>();

  ngOnInit() {
    this.initEquipmentQuantity();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.equipmentQuantity) {
      this.equipmentQuantity = changes.equipmentQuantity.currentValue;
      this.initEquipmentQuantity();
    }
  }

  public updateValue(event, containerName: ContainerName) {
    this.equipmentQuantity.set(
      containerName,
      new EquipmentQuantity(containerName, +event.target.value),
    );
    this.dispatchQuoteEvents();
  }

  public getEquipmentQuantity(containerName: string): number {
    return this.equipmentQuantity && this.equipmentQuantity.get(containerName)
      ? this.equipmentQuantity.get(containerName).getValue()
      : 1;
  }

  public dispatchQuoteEvents(): void {
    const { equipmentQuantity, showGrandTotal, grandTotalCurrency } = this;
    this.dispatchedQuoteEvents.emit({
      equipmentQuantity,
      showGrandTotal,
      grandTotalCurrency,
    });

    this.eventService.eventBus.emit({
      event: eventType.quoteAverageMarginUpdated,
      data: this.quote(),
    });
  }

  private initEquipmentQuantity(): void {
    const equipmentQuantity = new Map<string, EquipmentQuantity>();
    for (const containerName of this.equipment()) {
      equipmentQuantity.set(
        containerName,
        new EquipmentQuantity(
          containerName,
          this.getEquipmentQuantity(containerName),
        ),
      );
    }
    this.equipmentQuantity = equipmentQuantity;
  }
}
